import React from 'react';
import { Wrapper } from './NavigationItem.style';

interface NavigationItemProps {
  label: React.ReactNode;
  isActive?: boolean;
  link?: string;
  onClick?: () => void;
}

const NavigationItem: React.FC<NavigationItemProps> = ({
  label,
  link,
  onClick,
  isActive,
}) => {
  return (
    <Wrapper isActive={isActive}>
      <a href={link} onClick={onClick}>
        {label}
      </a>
    </Wrapper>
  );
};

export default NavigationItem;
